__turbopack_context__.v({
  "block": "button-module-scss-module__NC-NNa__block",
  "blue": "button-module-scss-module__NC-NNa__blue",
  "button": "button-module-scss-module__NC-NNa__button",
  "default": "button-module-scss-module__NC-NNa__default",
  "gray": "button-module-scss-module__NC-NNa__gray",
  "pink": "button-module-scss-module__NC-NNa__pink",
  "secondary": "button-module-scss-module__NC-NNa__secondary",
  "simple-text": "button-module-scss-module__NC-NNa__simple-text",
  "size-full": "button-module-scss-module__NC-NNa__size-full",
  "size-lg": "button-module-scss-module__NC-NNa__size-lg",
  "size-md": "button-module-scss-module__NC-NNa__size-md",
  "size-sm": "button-module-scss-module__NC-NNa__size-sm",
  "yellow": "button-module-scss-module__NC-NNa__yellow",
});
